(function($) {

    var $sliding = false;
    $(".sidebar-nav-toggle").on("mousedown touchend", function (e) {
        e.preventDefault();

        if($sliding == true)
            return;
        
        var $sidenav = $(".sidebar-navigation .navigation"),
        $sidenavtoggle = $(this).children("i");
        $sliding = true;

        $sidenav.toggleClass('open');

        if($sidenav.hasClass('open')){
            $sidenavtoggle.removeClass('fa-bars').addClass('fa-xmark');
            $sidenav.slideDown(function(){
                $sliding = false;
            });
        } else {
            $sidenavtoggle.addClass('fa-bars').removeClass('fa-xmark');
            $sidenav.slideUp(function(){
                $sliding = false;
            });
        }
        return false;
    });

    $(window).on("resize", function () {
        let $nav = $(".sidebar-navigation .navigation");
        if($(window).width() > 992) {
            $nav.css("display", "block");
        }
    });

    $(".sidebar-navigation .navigation .menu .menu-item-has-children").each(function () {
        if( $(this).hasClass('current-menu-parent') ){
            $(this).children("a").after('<div class="toggle"><i class="fa-light fa-chevron-up"></i></div>');
        } else {
            $(this).children("a").after('<div class="toggle"><i class="fa-light fa-chevron-down"></i></div>');
        }
    });

    var $sideNavSliding = false;
    $(".sidebar-navigation .navigation .toggle").on("mousedown touchend", function (e) {
        e.preventDefault();

        if($sideNavSliding == true)
            return;

        $(this).children('i').toggleClass('fa-chevron-up fa-chevron-down');
        
        $sideNavSliding = true;

        $(this).next('.sub-menu').slideToggle(function(){
            $sideNavSliding = false;
        });
        return false;
    });

})( jQuery );